module.exports = __webpack_public_path__ + "static/media/logo.cfd0c72c.svg";